import { render } from "./BackPaper.vue?vue&type=template&id=187bdc8a"
import script from "./BackPaper.vue?vue&type=script&lang=js"
export * from "./BackPaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__